import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle() {
  const [theme, setTheme] = useState(() => localStorage.getItem("bo_theme") || "light");
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("bo_theme", theme);
  }, [theme]);
  return (
    <button onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))} data-testid="theme-toggle"
      title={theme === "dark" ? "Byt till ljust läge" : "Byt till mörkt läge"}
      className="grid place-items-center h-9 w-9 rounded-xl bg-secondary/60 border border-border text-muted-foreground hover:text-foreground transition-colors">
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
